import { Injectable } from '@angular/core';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { AbstractService } from "@services/abstract.service";
import { HiringCompanyClass } from '@classes/hiring-company.class';

@Injectable({providedIn: 'root'})
export class HiringCompanyService extends AbstractService {
    constructor(
        public customHttpService: CustomHttpService,
    ) {
        super(customHttpService, new HiringCompanyClass());
        this.version = 'v1';
    }

  public getAllActive(): Promise<any>{
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/GetAllActive').then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }
}
